import React, { useEffect, useState, useRef, useMemo } from "react"
import { Link, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import TableContainer from "./goodServicesHeadListContainer"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import DeleteModal from "components/Common/DeleteModal"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import Spinners from "components/Common/Spinner"
import { ToastContainer } from "react-toastify"
import {
  deleteGoodServicesHeadMaster,
  getGoodServicesHeadMasterList,
} from "store/actions"

const GOODSSERVICESHEADLIST = props => {
  const navigate = useNavigate()
  document.title = "Goods & Services Head Master"

  const dispatch = useDispatch()
  const [codeId, setCodeId] = useState()

  const goodsServicesHeadState = state =>
    state.goodServicesHeadMaster.goodServicesHead.data
  const loadingState = state => state.goodServicesHeadMaster.loading

  const data = useSelector(goodsServicesHeadState) || []
  const loading = useSelector(loadingState) || false

  useEffect(() => {
    dispatch(getGoodServicesHeadMasterList())
    setIsEdit(false)
  }, [dispatch])

  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isLoading, setLoading] = useState(loading)

  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "srNo",
        sortBy: true,
        Cell: cellProps => {
          return (
            <h5 className="font-size-14 mb-1">{cellProps.row.index + 1}</h5>
          )
        },
      },
      {
        Header: "Head",
        accessor: "head_name",
        filterable: true,
        Cell: cellProps => {
          return (
            <h5 className="font-size-14 mb-1">
              {cellProps.row.original.head_text}
            </h5>
          )
        },
      },
      {
        Header: "Goods/Services",
        accessor: "good_and_service_category",
        filterable: true,
        Cell: cellProps => {
          return (
            <h5 className="font-size-14 mb-1">
              {cellProps.row.original.good_and_service_category || "N/A"}
            </h5>
          )
        },
      },
      {
        Header: "Is Active",
        accessor: "is_active",
        filterable: true,
        Cell: cellProps => {
          return (
            <h5 className="font-size-14 mb-1">
              {cellProps.row.original.is_active ? "Yes" : "No"}
            </h5>
          )
        },
      },
      {
        Header: "Action",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              {permission
                .filter(
                  item =>
                    item.page === "/edit-goods-services-head-master/:id" &&
                    item.access === 1
                )
                .map((item, index) => (
                  <Link
                    key={index}
                    to={`/settings/edit-goods-services-head-master/${cellProps.row.original.id}`}
                    className="text-success"
                  >
                    <i
                      className="mdi mdi-pencil font-size-18"
                      id="edittooltip"
                      style={{ color: "#3366cc" }}
                    />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                ))}
              {permission
                .filter(
                  item =>
                    item.page === "delete-goods-services-head-master" &&
                    item.access === 1
                )
                .map((item, index) => (
                  <Link
                    key={index}
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const recordId = cellProps.row.original.id
                      onClickDelete(recordId)
                    }}
                  >
                    <i
                      className="mdi mdi-delete font-size-18"
                      id="deletetooltip"
                      style={{ color: "#3366cc" }}
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                ))}
            </div>
          )
        },
      },
    ],
    []
  )

  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = recordId => {
    setCodeId({ id: recordId })
    setDeleteModal(true)
  }

  const handleDeleteRecord = () => {
    if (codeId && codeId.id) {
      dispatch(deleteGoodServicesHeadMaster(codeId.id))
    }
    setDeleteModal(false)
  }

  const [permission] = useState(JSON.parse(localStorage.getItem("permission")))

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteRecord}
        onCloseClick={() => setDeleteModal(false)}
        delete="association"
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Goods & Services Head Master"
            breadcrumbItem="Goods & Services Head List"
          />

          <Row>
            {isLoading ? (
              <Spinners setLoading={setLoading} />
            ) : (
              <Col lg="12">
                <Card>
                  <CardBody>
                    <TableContainer
                      isPagination={true}
                      columns={columns}
                      data={data}
                      isGlobalFilter={true}
                      isShowingPageLength={true}
                      isAddUserList={true}
                      // isAddUserList={permission && permission[12].access}
                      iscustomPageSizeOptions={true}
                      customPageSize={10}
                      tableClass="table align-middle table-nowrap table-hover"
                      theadClass="table-light"
                      paginationDiv="col-sm-12 col-md-7"
                      pagination="pagination pagination-rounded justify-content-end mt-4"
                    />
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  )
}

export default withRouter(GOODSSERVICESHEADLIST)
